<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M23 13.43h-1.63v-3a5.38 5.38 0 10-10.75 0v3H9a2 2 0 00-2 2v9.5a2 2 0 002 2h14a2 2 0 002-2v-9.5a2 2 0 00-2-2zm-10.38-3a3.38 3.38 0 116.75 0v3h-6.75zM23 24.93H9v-9.5h14z"/><path d="M14.73 22.44a.51.51 0 00.34.14.51.51 0 00.36-.15L19.8 18a.5.5 0 000-.71.49.49 0 00-.7 0l-4 4.09-2.16-2a.5.5 0 00-.71 0 .5.5 0 000 .71z"/></svg>